import { cva } from "../../../node_modules/.pnpm/class-variance-authority@0.7.1/node_modules/class-variance-authority/dist/index.js";
import { cn } from "../../../lib/utils.js";
const stepperRootVariants = cva(
  "flex",
  {
    variants: {
      orientation: {
        vertical: "flex-col",
        horizontal: ""
      },
      size: {
        default: "gap-2",
        small: "gap-1"
      }
    },
    defaultVariants: {
      orientation: "horizontal",
      size: "default"
    }
  }
), stepperItemVariants = cva(
  "relative flex justify-center w-full px-4 gap-2 group cursor-pointer",
  {
    variants: {
      orientation: {
        vertical: "flex-col",
        horizontal: ""
      }
    },
    defaultVariants: {
      orientation: "horizontal"
    }
  }
), stepperGroupVariants = cva(
  "flex flex-col",
  {
    variants: {
      orientation: {
        vertical: "gap-2",
        horizontal: "items-center"
      }
    },
    defaultVariants: {
      orientation: "horizontal"
    }
  }
), stepperIconAndMetaVariants = cva(
  "flex",
  {
    variants: {
      orientation: {
        vertical: "",
        horizontal: "flex-col"
      }
    },
    defaultVariants: {
      orientation: "horizontal"
    }
  }
), stepperTriggerVariants = cva(
  cn`
    inline-flex justify-center items-center border rounded-full
    group-data-[state=completed]:text-white
    group-data-[state=active]:border   group-data-[state=active]:border-(--primary-1)
    group-data-[state=active]:text-(--primary-1)
    group-data-[state=inactive]:border group-data-[state=inactive]:border-(--border-3-alpha)
    group-data-[state=inactive]:text-(--border-3-alpha)
  `,
  {
    variants: {
      status: {
        default: "group-data-[state=completed]:bg-(--primary-1)",
        error: "group-data-[state=completed]:bg-(--red-9)"
      },
      size: {
        default: "size-10 text-xl",
        small: "size-6 text-sm"
      }
    },
    defaultVariants: {
      status: "default",
      size: "default"
    }
  }
), stepperSeparatorVariants = cva(
  "block rounded-full shrink-0",
  {
    variants: {
      orientation: {
        vertical: "relative w-0.5 h-20",
        horizontal: "absolute h-0.5"
      },
      status: {
        default: "bg-(--border-3-alpha) group-data-[state=completed]:bg-(--primary-1)",
        error: "bg-(--red-9)"
      },
      size: {
        default: "",
        small: ""
      }
    },
    compoundVariants: [
      {
        size: "default",
        orientation: "horizontal",
        class: "top-5 right-[calc(50%+30px)] left-[calc(-50%+20px)]"
      },
      {
        size: "small",
        orientation: "horizontal",
        class: "top-2.5 right-[calc(50%+20px)] left-[calc(-50%+15px)]"
      },
      {
        size: "default",
        orientation: "vertical",
        class: "left-4.5"
      },
      {
        size: "small",
        orientation: "vertical",
        class: "left-2.5"
      }
    ],
    defaultVariants: {
      orientation: "horizontal",
      status: "default",
      size: "default"
    }
  }
), stepperMetaInfoVariants = cva(
  "relative w-full",
  {
    variants: {
      orientation: {
        vertical: "ml-2",
        horizontal: "text-center"
      },
      size: {
        default: "mt-2",
        small: "mt-1"
      }
    },
    defaultVariants: {
      orientation: "horizontal",
      size: "default"
    }
  }
), stepperMetaInfo2Variants = cva(
  null,
  {
    variants: {
      orientation: {
        vertical: "absolute top-0 left-0 w-full",
        horizontal: ""
      }
    },
    defaultVariants: {
      orientation: "horizontal"
    }
  }
), stepperTitleVariants = cva(
  [
    "font-medium",
    "group-data-[state=active]:text-(--primary-1)",
    "group-data-[state=inactive]:text-(--border-3-alpha)"
  ],
  {
    variants: {
      status: {
        default: "group-data-[state=completed]:text-(--primary-1)",
        error: "group-data-[state=completed]:text-(--red-9)"
      },
      size: {
        default: "text-xl",
        small: ""
      }
    },
    defaultVariants: {
      status: "default",
      size: "default"
    }
  }
), stepperDescriptionVariants = cva(
  "hidden sm:block text-xs",
  {
    variants: {
      status: {
        default: "text-(--gray-text-2)",
        error: "text-(--red-9)"
      }
    },
    defaultVariants: {
      status: "default"
    }
  }
);
export {
  stepperDescriptionVariants,
  stepperGroupVariants,
  stepperIconAndMetaVariants,
  stepperItemVariants,
  stepperMetaInfo2Variants,
  stepperMetaInfoVariants,
  stepperRootVariants,
  stepperSeparatorVariants,
  stepperTitleVariants,
  stepperTriggerVariants
};
//# sourceMappingURL=variants.js.map
